import { defineComponent as _defineComponent } from 'vue'
import salesCustomerGroupsDetailedGenerator, {
  TreemapMode,
} from '@/models/Charts/salesCustomerGroupsDetailedGenerator';
import { DetailedViewEnum } from '@/models/enums/WidgetEnum';
import { SalesCustomerGroupsDetailedData } from '@/models/Charts/chartsData';
import { EChartsOption } from 'echarts';
import { isEmpty } from '@/utils/misc';
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import { customersService } from '@/services/tenants.service';
import { useI18n } from '@/composables/i18n';
import { computed, onBeforeUnmount, onMounted, ref, shallowRef } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DetailedCustomerGroups',
  props: {
    selectedTimeFilter: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  selectedTimeFilter: [string, string];
};





const { t } = useI18n();

const fields: TreemapMode[] = ['all', 'new', 'pending', 'expired'];

const treemapMode = ref<TreemapMode>('all');
const data = ref<SalesCustomerGroupsDetailedData[] | null>([]);
const option = shallowRef<EChartsOption>({});

const customerIdDh = computed<number>(
  () => customersService.store.currentIdDh()!,
);
const generator: ChartGenerator<SalesCustomerGroupsDetailedData[]> =
  new salesCustomerGroupsDetailedGenerator(
    DetailedViewEnum.SalesCustomerGroupsDetailed,
    customerIdDh.value,
  );

const loading = ref(false);

onMounted(async () => {
  await update();
});

async function update(): Promise<void> {
  loading.value = true;
  try {
    if (isEmpty(data.value)) {
      data.value = await generator.getData([], [], props.selectedTimeFilter);
    }

    if (isEmpty(data.value)) {
      loading.value = false;
      return;
    }

    const params = {
      mode: treemapMode.value,
    };
    option.value = generator.updateOptions(data.value!, params);
  } finally {
    loading.value = false;
  }
}

async function onModeChange(value: TreemapMode) {
  treemapMode.value = value;
  await update();
}

const noData = computed<boolean>(() => !loading.value && isEmpty(data.value));

onBeforeUnmount(() => {
  generator.abort();
});

return { __sfc: true,props, emit, t, fields, treemapMode, data, option, customerIdDh, generator, loading, update, onModeChange, noData }
}

})